import React from "react";

function ClientInfoCard({
  lead,
  proposalId,
}) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        marginBottom: "40px",
        gap: "50px",
      }}
    >
      {/* LEFT */}

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "18px",
        }}
      >
        <InfoRow
          label="Prepared for :" 
          value={lead?.name || "Client Name"}
        />

        <InfoRow
          label="Email :"
          value={lead?.email || "client@email.com"}
        />

      
      </div>

      {/* RIGHT */}

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "18px",
        }}
      >
        <InfoRow
          label="Date :"
          value={new Date().toLocaleDateString()}
        />
         <InfoRow
          label="Mobile :"
          value={lead?.phone || "+91 XXXXXXXX"}
        />
      </div>
    </div>
  );
}

const InfoRow = ({
  label,
  value,
}) => {
  return (
    <div
      style={{
        display: "flex",
        gap: "15px",
      }}
    >
      <strong
        style={{
          minWidth: "140px",
          color: "#5d5d5d",
          fontSize: "13px",
        }}
      >
        {label}
      </strong>

      <span
        style={{
          color: "#444",
        }}
      >
        {value}
      </span>
    </div>
  );
};

export default ClientInfoCard;